import { RecipeDetails } from '../../../../interfaces/RecipeDetails';
import { RecipeIngredient } from '../../../../interfaces/RecipeIngredient';
import {
  RecipeFormValues,
  RecipeIngredientFormValue,
} from '../../interfaces/RecipeFormValues';
import {
  measurementToUnitMacros,
  pickMacros,
} from '../measurementToUnitMacros/measurementToUnitMacros';

const ingredientToFormValue = (
  ingredient: RecipeIngredient,
): RecipeIngredientFormValue => ({
  ingredientId: ingredient.id,
  foodId: null,
  name: ingredient.name,
  amount: ingredient.amount,
  amountUnit: ingredient.amountUnit,
  isNetwork: ingredient.wasFoundOnMyNedDiary || ingredient.my_net_diary_bean_id != null,
  my_net_diary_bean_id: ingredient.my_net_diary_bean_id,
  perUnit: pickMacros(ingredient),
  measurements: ingredient.measurements.map(measurementToUnitMacros),
});

export const recipeToFormValues = (recipe: RecipeDetails): RecipeFormValues => ({
  id: recipe.id,
  name: recipe.name,
  servingSize: recipe.servingSize,
  amount: recipe.amount,
  servingMeasurement: recipe.servingMeasurement,
  description: recipe.description ?? '',
  image: null,
  ingredients: recipe.ingredients.map(ingredientToFormValue),
});
